import VCCapitalCallPortionsList from "./VCCapitalCallPortionsList";

export default VCCapitalCallPortionsList;
